export default class Icons {
  static load(path) {
    const basePath = window.iconsPath || '/';
    const finalPath = path || `${basePath.replace(/\/$/, '')}/assets/icons.svg`;

    fetch(finalPath)
      .then((res) => {
        if (!res.ok) {
          throw new Error('icons_file_not_found');
        }
        return res.text();
      })
      .then((data) => {
        if (document.getElementById('svg-icons-sprite')) {
          return;
        }

        const svgContainer = document.createElement('div');
        svgContainer.id = 'svg-icons-sprite';
        svgContainer.hidden = true;
        svgContainer.innerHTML = data;
        document.body.appendChild(svgContainer);
      })
      .catch((error) => {
        console.error('icons_load_failed', error.message || error);
      });
  }
}
